// extracted by mini-css-extract-plugin
export default {"dev__wrap":"dev_dev__wrap__674gN","dev":"dev_dev__OQ3HD","dev__title":"dev_dev__title__yvQYo","dev__description":"dev_dev__description__2vMyh"};